export default "__VITE_ASSET__CRlIe4L4__"